import { Component, Input, OnInit } from '@angular/core';
import { IHistorialSancion } from '../../containers/bandeja-principal/administrador/gestion/sanciones-personas/sanciones-persona.interface';
import { ModalGenericoModel } from 'src/app/shared/models/modal.model';
import { SancionesPersonasService } from '../../containers/bandeja-principal/administrador/gestion/sanciones-personas/sanciones-personas.service';
import { DatoPaginadoModel } from 'src/app/shared/models/dato-paginado.model';

@Component({
  selector: 'app-modal-historial-sancion-persona',
  templateUrl: './modal-historial-sancion-persona.component.html',
  styleUrls: ['./modal-historial-sancion-persona.component.scss']
})
export class ModalHistorialSancionPersonaComponent implements OnInit {

  @Input() sancion_id?: number;
  items: IHistorialSancion[]
  headers: Array<string>;
  dataTabla:DatoPaginadoModel;
  paginaActual = 1;
  modalGenerico: ModalGenericoModel;
  constructor(private sancionPersonasService: SancionesPersonasService) { }

  ngOnInit(): void {
    this.getData();
    this.headers = ['Descripción','Fecha','Usuario','Motivo'];

    this.modalGenerico = {
			titulo: 'Historial de sanciones'
		};
  }

  getData(): void{
    this.sancionPersonasService
        .getHistorial(this.sancion_id,this.paginaActual)
        .subscribe(response =>{
          this.dataTabla = response.data as DatoPaginadoModel;
          if(response.result){
            this.items = response.data.items;
          }
        });
  }
  onPaginado(page: number){
    this.paginaActual=page;
    this.getData();
  }
  

}
